import api from '../../../services/api';

// employee providers
export const UsersHTTP = {
  sendSMS: (id = '', params = {}) => api.post(`/users/sms/${id}`, params),
};
